'use client'
import Link from 'next/link'
import { useState } from 'react'

import facebookIcon from '@/assets/images/icon/facebook-icon.svg'
import instagramIcon from '@/assets/images/icon/instagram-icon.svg'
import twitterIcon from '@/assets/images/icon/twitter-icon.svg'
import wikipediaIcon from '@/assets/images/icon/wikipedia-icon.svg'
import { BLUR_DATA_URL_BASE64, S3_PREFIX } from '@/shared/constants'
// import Card from '@/shared/components/card'
import MyImage from '@/shared/components/myImage'
import { convertDt24h, dateCheck } from '@/shared/utils'
import CustomLink from '../../customLink'

export default function PlayerInfo({ data }: any) {
  const [showMore, setShowMore] = useState(false)
  function handleDesc() {
    setShowMore(prev => !prev)
  }

  return (
    <div>
      <h3 className="text-base md:text-2xl font-bold text-textOffWhite mb-3">Player Info</h3>
      <div className="mb-3">
        {data?.aMajorTeams?.length ? (
          <>
            <div className="grid grid-cols-12 md:gap-12 md:py-5 md:border-b md:border-separator md:last:border-b-0 ">
              <div className="py-3 border-b md:border-b-0 border-separator  md:py-0 col-span-12 md:col-span-5 flex items-center text-xs md:text-sm font-medium text-textOffWhite">
                <span className="text-t-secondary w-28 font-normal">Full Name</span>
                {data?.sFullName || data?.sShortName || '-'}
              </div>
              {/* {data?.sCountryFull && (
								<div className='py-3 border-b md:border-b-0 border-separator  md:py-0 col-span-12 md:col-span-5 flex items-center text-xs md:text-sm font-medium text-textOffWhite'>
									<span className='text-t-secondary w-28 font-normal'>Nationality</span>
									{data?.sCountryFull || '-'}
								</div>
							)} */}
            </div>
            <div className="grid grid-cols-12 md:gap-12 md:py-5 md:border-b md:border-separator md:last:border-b-0">
              {data?.dBirthDate && (
                <div className="py-3 border-b md:border-b-0 border-separator  md:py-0 col-span-12 md:col-span-5 flex items-center text-xs md:text-sm font-medium text-textOffWhite">
                  <span className="text-t-secondary w-28 font-normal">Birth Date</span>
                  {data?.dBirthDate ? convertDt24h(dateCheck(data?.dBirthDate)) : '-'}
                </div>
              )}
              {data?.sBirthPlace && (
                <div className="py-3 border-b md:border-b-0 border-separator  md:py-0 col-span-12 md:col-span-5 flex items-center text-xs md:text-sm font-medium text-textOffWhite">
                  <span className="text-t-secondary w-28 font-normal">Birth Place</span>
                  {data?.sBirthPlace || '-'}
                </div>
              )}
            </div>
            <div className="grid grid-cols-12 md:gap-12 md:py-5 md:border-b md:border-separator md:last:border-b-0 ">
              {data?.sBattingStyle && (
                <div className="py-3 border-b md:border-b-0 border-separator  md:py-0 col-span-12 md:col-span-5 flex items-center text-xs md:text-sm font-medium text-textOffWhite">
                  <span className="text-t-secondary w-28 font-normal">Batting Style</span>
                  {data?.sBattingStyle?.replaceAll('_', ' ')}
                </div>
              )}
              {data?.sBowlingStyle && (
                <div className="py-3 border-b md:border-b-0 border-separator  md:py-0 col-span-12 md:col-span-5 flex items-center text-xs md:text-sm font-medium text-textOffWhite">
                  <span className="text-t-secondary w-28 font-normal">Bowling Style</span>
                  {data?.sBowlingStyle?.replaceAll('_', ' ') || '-'}
                </div>
              )}
            </div>
            <div className="flex items-center py-5 border-b border-separator last:border-b-0">
              <span className="text-t-secondary w-28 flex-shrink-0 text-xs md:text-sm font-normal">
                Teams
              </span>
              <div className="flex overflow-x-auto md:grid md:grid-cols-12 gap-2 w-full ">
                {data?.aMajorTeams?.map((teams: any) => {
                  return teams.oSeo.sSlug && teams.oSeo.eStatus === 'a' ? (
                    <CustomLink
                      href={`/${teams.oSeo.sSlug}`}
                      key={teams.sTitle}
                      className="flex items-center text-nowrap md:text-wrap col-span-12 lg:col-span-3 text-xs md:text-sm"
                    >
                      <div className="w-8 h-8 me-2 flex-shrink-0">
                        <MyImage
                          src={teams?.oImg?.sUrl ? `${S3_PREFIX}${teams?.oImg?.sUrl}` : ''}
                          alt={teams.sTitle}
                          blurDataURL={BLUR_DATA_URL_BASE64}
                          placeholder="blur"
                          height={20}
                          width={20}
                          className="w-full h-full rounded-full"
                          placeholderType="team"
                        />
                      </div>
                      {teams?.sTitle}
                    </CustomLink>
                  ) : (
                    <div
                      key={teams.sTitle}
                      className="flex items-center text-nowrap md:text-wrap col-span-12 lg:col-span-3 text-xs md:text-sm"
                    >
                      <div className="w-8 h-8 me-2 flex-shrink-0">
                        <MyImage
                          src={teams?.oImg?.sUrl ? `${S3_PREFIX}${teams?.oImg?.sUrl}` : ''}
                          alt={teams.sTitle}
                          blurDataURL={BLUR_DATA_URL_BASE64}
                          placeholder="blur"
                          height={20}
                          width={20}
                          placeholderType="team"
                          className="w-full h-full rounded-full"
                        />
                      </div>
                      {teams?.sTitle}
                    </div>
                  )
                })}
              </div>
            </div>
          </>
        ) : null}
        {(data?.oSocialMedia?.oFacebook?.sHandle ||
          data?.oSocialMedia?.oInstagram?.sHandle ||
          data?.oSocialMedia?.oWikipedia?.sHandle ||
          data?.oSocialMedia?.oTwitter?.sHandle) && (
          <>
            <div
              className={`flex items-center pt-5 pb-2 border-b border-separator last:border-b-0`}
            >
              <span className="text-t-secondary w-28 flex-shrink-0 text-xs md:text-sm font-normal">
                Socials
              </span>
              <div className="flex max-w-screen text-nowrap overflow-x-auto md:overflow-x-hidden md:flex-wrap">
                {data?.oSocialMedia?.oWikipedia?.sHandle && (
                  <Link
                    target="_blank"
                    href={data?.oSocialMedia?.oWikipedia?.sUrl}
                    className="flex items-center py-1 px-4 border border-borderStroke bg-theme text-subSectionText text-[10px] sm:text-sm rounded-lg my-1 me-2 md:me-4 last:me-0 break-all"
                  >
                    <span className="w-4 h-4 me-2 flex-shrink-0">
                      <MyImage
                        src={wikipediaIcon}
                        alt="wikipediaIcon"
                        height={20}
                        width={20}
                        className="w-full h-full"
                      />
                    </span>
                    {data?.oSocialMedia?.oWikipedia?.sHandle}
                  </Link>
                )}
                {data?.oSocialMedia?.oInstagram?.sHandle && (
                  <Link
                    target="_blank"
                    href={data?.oSocialMedia?.oInstagram?.sUrl}
                    className="flex items-center py-1 px-4 border border-borderStroke bg-theme text-subSectionText text-[10px] sm:text-sm rounded-lg my-1 me-2 md:me-4 last:me-0 break-all"
                  >
                    <span className="w-4 h-4 me-2">
                      <MyImage
                        src={instagramIcon}
                        alt="instagramIcon"
                        height={20}
                        width={20}
                        className="w-full h-full"
                      />
                    </span>
                    {data?.oSocialMedia?.oInstagram?.sHandle}
                  </Link>
                )}
                {data?.oSocialMedia?.oFacebook?.sHandle && (
                  <Link
                    target="_blank"
                    href={data?.oSocialMedia?.oFacebook?.sUrl}
                    className="flex items-center py-1 px-4 border border-borderStroke bg-theme text-subSectionText text-[10px] sm:text-sm rounded-lg my-1 me-2 md:me-4 last:me-0 break-all"
                  >
                    <span className="w-4 h-4 me-2">
                      <MyImage
                        src={facebookIcon}
                        alt="facebook"
                        height={20}
                        width={20}
                        className="w-full h-full"
                      />
                    </span>
                    {data?.oSocialMedia?.oFacebook?.sHandle}
                  </Link>
                )}
                {data?.oSocialMedia?.oTwitter?.sHandle && (
                  <Link
                    href={data?.oSocialMedia?.oTwitter?.sUrl}
                    className="flex items-center py-1 px-4 border border-borderStroke bg-theme text-subSectionText text-[10px] sm:text-sm rounded-lg my-1 me-2 md:me-4 last:me-0 break-all"
                  >
                    <span className="w-4 h-4 me-2">
                      <MyImage
                        src={twitterIcon}
                        alt="twitterIcon"
                        height={20}
                        width={20}
                        className="w-full h-full"
                      />
                    </span>
                    {data?.oSocialMedia?.oTwitter?.sHandle}
                  </Link>
                )}
              </div>
            </div>
          </>
        )}
        {data?.bIsCustomPlayerDescription && (
          <>
            <div className="flex py-5 border-b border-separator last:border-b-0 text-xs md:text-sm font-medium">
              <span className="text-t-secondary w-28 flex-shrink-0 font-normal">About</span>
              <div className="flex w-full flex-col">
                <p
                  dangerouslySetInnerHTML={{
                    __html: showMore
                      ? data?.sCustomPlayerDescription
                      : data?.sCustomPlayerDescription.substring(0, 200)
                  }}
                ></p>
                <span className="text-primary-500 cursor-pointer" onClick={handleDesc}>
                  {showMore ? 'Read Less' : 'Read More'}
                </span>
              </div>
            </div>
          </>
        )}
      </div>
      {/* <Card
				defaultBordered={true}
				className='mb-6 flex-col text-sm !py-0'>
				<div className='grid grid-cols-12 gap-2 w-full py-1 pt-3'>
					<div className='flex col-span-12 md:col-span-6 xl:col-span-4 mb-4'>

					</div>



				</div>

				
			</Card> */}
    </div>
  )
}
